import {
  DRAFT_APPROVAL_KIND,
  draftResolutionOf,
} from '../../../contracts/approval-kinds';
import type { ToolUseItem } from '../../../contracts/harness.types';

import { deniedApprovalUserNote } from './deniedApprovalUserNote';

/** A draft the clinician discarded: denied without a note to steer Heidi. */
export const isDiscardedDraftApproval = (item: ToolUseItem): boolean => {
  const approval = item.approval;
  if (approval?.status !== 'denied') return false;
  const resolution = draftResolutionOf(approval);
  if (resolution) return resolution.kind === 'draft.discarded';
  return (
    approval.approval_kind === DRAFT_APPROVAL_KIND &&
    deniedApprovalUserNote(item) === null
  );
};
